import { render, staticRenderFns } from "./regProgress.vue?vue&type=template&id=14b70e6e&scoped=true&"
import script from "./regProgress.vue?vue&type=script&lang=js&"
export * from "./regProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b70e6e",
  null
  
)

export default component.exports